<template>
  <v-container>
    <material-card
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      :title="langs[localization].newOrders"
      class="d-flex flex-wrap"
    >
      <v-card-title class="search_block">
        <v-spacer></v-spacer>
        <div class="search_field d-flex">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="langs[localization].search"
            single-line
            hide-details
          ></v-text-field>
          <OrderHeadersDialog/>
        </div>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="neworders"
        :search="search"
        :footer-props="{
             'items-per-page-text': langs[localization].rowsPerPage
        }"
      >
        <template v-slot:item.orderdate="{ item }">
          {{ formatDate(item.orderdate) }}
        </template>
        <template v-slot:item.deliverydate="{ item }">
          {{ formatDate(item.deliverydate) }}
        </template>
        <template v-slot:item.invoicecustomer="{ item }">
          {{ item.invoicecustomer.name }}
        </template>
        <template v-slot:item.orderstatus="{ item }">
          <v-chip
            v-if="item.orderstatus == 'new'"
            color="red"
            label
          >
            {{ langs[localization].new }}
          </v-chip>
          <v-chip
            v-if="item.orderstatus == 'open'"
            color="blue"
            label
          >
            {{ langs[localization].open }}
          </v-chip>
          <v-chip
            v-if="item.orderstatus == 'canceled'"
            label
          >
            {{ langs[localization].canceled }}
          </v-chip>
          <v-chip
            v-if="item.orderstatus == 'delivered'"
            label
            color="green"
          >
            {{ langs[localization].delivered }}
          </v-chip>
          <v-chip
            v-if="item.orderstatus == 'accepted'"
            label
            color="yellow"
          >
            {{ langs[localization].accepted }}
          </v-chip>
          <v-chip
            v-if="item.orderstatus == 'confirmed'"
            label
            color="cyan lighten-2"
          >
            {{ langs[localization].confirmed }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <td class="d-flex">
              <router-link :to="{ name: 'OrderView', params: {id: item.orderid}}">
                <v-btn
                  class="ml-2 mt-3"
                  height="23"
                  color="primary"
                >
                  {{ langs[localization].open }}
                </v-btn>
              </router-link>
              <v-btn
                class="ml-2 mt-3"
                height="23"
                color="primary"
                @click="printDoc(item)"
              >
                  {{ langs[localization].print }}
              </v-btn>
          </td>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import translate from '@/plugins/translation'
import OrderHeadersDialog from '@/components/OrderHeadersDialog'

export default {
  //Komponentti joka näyttää kaikki uudet tilaukset
  name: 'ViewRow',
  components: {
    OrderHeadersDialog
  },
  data: function () {
    return {
      langs: translate,
      search: '',
    }
  },
  computed: {
    ...mapState({
      neworders: state => state.tables.neworders,
      localization: state => state.auth.localization
    }),
    ...mapGetters({
      headers: 'auth/getOrdersHeaders'
    }),
  },
  methods: {
    formatDate(timestamp) {
      moment.locale('fi');
      if(typeof timestamp !== 'object') {
        return moment(timestamp).format('L')
      } else {
        const date = new Date(timestamp.seconds * 1000).toISOString().substr(0, 10)
        return moment(date).format('L')
      }
    },
    printDoc(item) {
      let WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      let delivery = {}
      let invoice = {}
      let ordersumm = 0
      item.orderrows.forEach(el => {
        ordersumm += el.unitprice * el.confirmed_amount
      })

      if (!item.deliverysite) {
        delivery.name = item.deliverycustomer.name
        delivery.adress = item.deliverycustomer.streetadress ? item.deliverycustomer.streetadress : ''
        delivery.city = item.deliverycustomer.city ? item.deliverycustomer.city : ''
        delivery.id = item.deliverycustomer.deliverycustomerid ? item.deliverycustomer.deliverycustomerid : ''
      } else {
        delivery.name = item.deliverysite.name
        delivery.adress = item.deliverysite.streetadress ? item.deliverysite.streetadress : ''
        delivery.city = item.deliverysite.city ? item.deliverysite.city : ''
        delivery.id = item.deliverysite.deliverysiteid ? item.deliverysite.deliverysiteid : ''
      }

      if (!item.invoicecustomer) {
        invoice.name = item.deliverycustomer.name
        invoice.adress = item.deliverycustomer.streetadress ? item.deliverycustomer.streetadress : ''
        invoice.city = item.deliverycustomer.city ? item.deliverycustomer.city : ''
        invoice.id = item.deliverycustomer.deliverycustomerid ? item.deliverycustomer.deliverycustomerid : ''
      } else {
        invoice.name = item.invoicecustomer.name
        invoice.adress = item.invoicecustomer.streetadress ? item.invoicecustomer.streetadress : ''
        invoice.city = item.invoicecustomer.city ? item.invoicecustomer.city : ''
        invoice.id = item.invoicecustomer.invoicecustomerid ? item.invoicecustomer.invoicecustomerid : ''
      }

      WinPrint.document.write(`
  <!DOCTYPE html>
  <html>
    <style>
    body { size: A4; margin: 0; }
    .content { width: 100%; }
    .row { display: flex; margin: 0 20px; justify-content: space-between; border-bottom: 1px solid #333333; }
    .col { width: 25%; }
    h4 { margin: 10px 0 10px 0; padding: 0px; }
    p { margin: 4px 0 4px 0; }
    ul { list-style-type: none; padding: 0; margin: 0; }
    li { padding: 0px }
    table { width: 95%; margin: 10px auto 0 auto; text-align: center; border: solid 1px #DDEEEE; border-collapse: collapse; border-spacing: 0; }
    th { font-size: 12px; padding: 5px; border: solid 1px #DDEEEE; }
    td { font-size: 10px; padding: 5px; border: solid 1px #DDEEEE; }
    </style>
    <body>
      <div class="content" id="print-content"></div>
    </body>
  </html>`);
      WinPrint.document.close();

      const doc = WinPrint.document
      const root = doc.getElementById('print-content')

      const el = (tag, text, className) => {
        const e = doc.createElement(tag)
        if (text !== undefined && text !== null) e.textContent = text
        if (className) e.className = className
        return e
      }

      const row1 = el('div', null, 'row')

      const col1 = el('div', null, 'col')
      col1.appendChild(el('h4', this.langs[this.localization].deliveryAddress))
      const ul1 = doc.createElement('ul')
      ;[delivery.name, delivery.adress, delivery.city, `ID: ${delivery.id}`].forEach(text => {
        const li = doc.createElement('li')
        li.appendChild(el('p', text))
        ul1.appendChild(li)
      })
      col1.appendChild(ul1)
      row1.appendChild(col1)

      const col2 = el('div', null, 'col')
      col2.appendChild(el('h4', this.langs[this.localization].orderDate))
      col2.appendChild(el('p', moment(new Date(item.orderdate.seconds * 1000)).format('L')))
      row1.appendChild(col2)

      const col3 = el('div', null, 'col')
      col3.appendChild(el('h4', this.langs[this.localization].desiredDeliveryDate))
      col3.appendChild(el('p', moment(new Date(item.deliverydate.seconds * 1000)).format('L')))
      row1.appendChild(col3)

      const col4 = el('div', null, 'col')
      col4.appendChild(el('h4', this.langs[this.localization].orderTotal))
      col4.appendChild(el('p', `${ordersumm} €`))
      row1.appendChild(col4)

      root.appendChild(row1)

      const row2 = el('div', null, 'row')

      const col5 = el('div', null, 'col')
      col5.appendChild(el('h4', this.langs[this.localization].billingInformation))
      const ul2 = doc.createElement('ul')
      ;[invoice.name, invoice.adress, invoice.city, `ID: ${invoice.id}`].forEach(text => {
        const li = doc.createElement('li')
        li.appendChild(el('p', text))
        ul2.appendChild(li)
      })
      col5.appendChild(ul2)
      row2.appendChild(col5)

      const col6 = el('div', null, 'col')
      col6.appendChild(el('h4', this.langs[this.localization].orderReference))
      col6.appendChild(el('p', item.customerref))
      row2.appendChild(col6)

      const col7 = el('div', null, 'col')
      col7.appendChild(el('h4', this.langs[this.localization].orderNumber))
      col7.appendChild(el('p', item.ordernumber))
      row2.appendChild(col7)

      const col8 = el('div', null, 'col')
      col8.appendChild(el('h4', this.langs[this.localization].deliveryDate))
      col8.appendChild(el('p', moment(new Date(item.confirmeddeliverydate.seconds * 1000)).format('L')))
      row2.appendChild(col8)

      root.appendChild(row2)

      const row3 = el('div', null, 'row')
      const col9 = el('div', null, 'col')
      col9.appendChild(el('h4', this.langs[this.localization].orderDetails))
      col9.appendChild(el('p', item.ordernotes))
      row3.appendChild(col9)
      root.appendChild(row3)

      const table = doc.createElement('table')
      table.className = 'table'

      const headerRow = doc.createElement('tr')
      ;[
        this.langs[this.localization].line,
        this.langs[this.localization].productNumber,
        'EAN',
        this.langs[this.localization].productName,
        this.langs[this.localization].orderAmount,
        this.langs[this.localization].confirmedAmount,
        this.langs[this.localization].unit,
        this.langs[this.localization].price,
        this.langs[this.localization].summ,
        this.langs[this.localization].deliveryDate,
        this.langs[this.localization].notes,
      ].forEach(text => {
        headerRow.appendChild(el('th', text))
      })
      table.appendChild(headerRow)

      const tbody = doc.createElement('tbody')
      item.orderrows.forEach((row, i) => {
        const tr = doc.createElement('tr')
        ;[
          i + 1,
          row.productno_supplier,
          row.eancode,
          row.productname,
          row.order_amount,
          row.confirmed_amount,
          row.unit,
          `${row.unitprice} €`,
          `${row.unitprice * row.confirmed_amount} €`,
          moment(new Date(row.deliverydate.seconds * 1000)).format('L'),
          row.notes,
        ].forEach(text => {
          tr.appendChild(el('td', text))
        })
        tbody.appendChild(tr)
      })
      table.appendChild(tbody)
      root.appendChild(table)

      WinPrint.document.title = `order_${item.ordernumber}`
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
  }
}
</script>

<style>
.v-card__title {
  font-size: 1.50rem !important;
}
</style>
